module.exports = __webpack_public_path__ + "static/media/move-right.45754c0e.svg";